import { render, staticRenderFns } from "./ChangeMapMenu.vue?vue&type=template&id=6b4f9203&scoped=true"
import script from "./ChangeMapMenu.vue?vue&type=script&lang=js"
export * from "./ChangeMapMenu.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b4f9203",
  null
  
)

export default component.exports